import { memo } from 'react';
import { 
  FunnelChart as FChart, Funnel, 
  LabelList,Cell
} from 'recharts';
import {getBarColor} from './utils';

export const FunnelChart = memo(({commonProps,widget ,data}:any) =>{
    const height = widget.height || '200px';
    return (
        <FChart style={{ width: '90%',height: height, aspectRatio: 1.618 }}
            
             margin={{ top: 10, right: 50, left: 0, bottom: 10 }} >
                <Funnel dataKey={widget.valueKey} data={data} isAnimationActive={false}>
                  {data?.map((entry: any, index: number) => (
                            <Cell 
                                key={`cell-${index}`} 
                                fill={getBarColor(widget.valueKey, entry, widget.fields, index)} 
                            />
                        ))}
                    <LabelList 
                            position="right" 
                            fill="#333" 
                            stroke="none" 
                            dataKey="name" 
                        />
                        <LabelList 
                            position="center" 
                            fill="#fff" 
                            stroke="none" 
                            dataKey={widget.valueKey} 
                        />
                </Funnel>
         </FChart>
    )

});